(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pre-order-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-preorder-popup]');
  if (!root) return;
  var nativeFetch = (window.fetch && window.fetch.bind(window)) || null;

  var PREORDER_TAG = (root.dataset.preorderTag || 'preorder').toLowerCase();
  var MATCH_ALL = PREORDER_TAG === '*'; // set tag to "*" to trigger on every product (testing)
  var SUPPRESS_DRAWER = root.dataset.suppressDrawer === 'true';
  var CONFIRM_ADD = root.dataset.confirmAdd === 'true';

  var dialogEl = root.querySelector('[data-preorder-dialog]');
  var mediaEl = root.querySelector('[data-preorder-media]');
  var imageEl = root.querySelector('[data-preorder-image]');
  var cardEl = root.querySelector('[data-preorder-card]');
  var thumbEl = root.querySelector('[data-preorder-thumb]');
  var titleEl = root.querySelector('[data-preorder-product-title]');
  var variantEl = root.querySelector('[data-preorder-variant]');
  var priceEl = root.querySelector('[data-preorder-price]');
  var messageEl = root.querySelector('[data-preorder-message]');
  var cancelBtn = root.querySelector('[data-preorder-cancel]');
  var messageTemplate = messageEl ? messageEl.innerHTML : '';
  var partialTplEl = root.querySelector('[data-preorder-partial-message]');
  var partialTemplate = partialTplEl ? partialTplEl.innerHTML.trim() : '';
  var splitEl = root.querySelector('[data-preorder-split]');

  var currentLineKey = null;
  var pendingForm = null;
  var bypassOnce = false;
  var skipInspectUntil = 0;

  function open() { root.hidden = false; document.body.style.overflow = 'hidden'; }

  function close() {
    if (root.hidden || root.__closing) return;

    var timer;
    var finish = function () {
      if (!root.__closing) return;              // run once
      root.__closing = false;
      clearTimeout(timer);                       // kill the stray fallback timer
      root.removeEventListener('animationend', onEnd);
      root.classList.remove('is-closing');
      root.hidden = true;
      document.body.style.overflow = '';
      pendingForm = null;
      ['overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet', 'no-scroll', 'scroll-lock', 'js-drawer-open'].forEach(function (c) {
        document.body.classList.remove(c);
        document.documentElement.classList.remove(c);
      });
    };
    var onEnd = function (e) { if (e.target === root || e.target === dialogEl) finish(); };

    root.__closing = true;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { finish(); return; }

    root.classList.add('is-closing');
    root.addEventListener('animationend', onEnd);
    timer = setTimeout(finish, 450);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    try {
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  root.querySelectorAll('[data-preorder-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });

  var keepBtn = root.querySelector('[data-preorder-keep]');
  if (keepBtn) {
    keepBtn.addEventListener('click', function () {
      if (CONFIRM_ADD && pendingForm) { performAdd(pendingForm); return; }
      close();
    });
  }

  function cartDrawerEl() {
    var sel = (root.dataset.cartDrawerSelector || '').trim() ||
      '[id^="CartDrawer"], cart-drawer, #CartDrawer, .cart-drawer, [id*="cart-drawer" i]';
    return document.querySelector(sel);
  }

  if (cancelBtn) {
    cancelBtn.addEventListener('click', close);
  }

  // split = { pre: units on pre-order, ready: units shipping now } or null
  // Proportion bar: a thin two-colour bar with the numbers at either end,
  // e.g. [=====green=====][========amber========]
  //       2 in stock                3 on pre-order
  function splitHtml(ready, pre) {
    return '<div class="po-split__bar" aria-hidden="true">' +
        (ready > 0 ? '<span class="is-ready" style="flex:' + ready + '"></span>' : '') +
        '<span class="is-pre" style="flex:' + pre + '"></span>' +
      '</div>' +
      '<div class="po-split__legend">' +
        (ready > 0 ? '<span class="is-ready">' + ready + ' in stock</span>' : '') +
        '<span class="is-pre">' + pre + ' on pre-order</span>' +
      '</div>';
  }

  // split = { pre: units on pre-order, ready: units in stock } or null
  function renderSplit(split) {
    if (!splitEl) return;
    var show = split && split.pre > 0 && (split.ready > 0 || split.pre > 1);
    if (!show) { splitEl.hidden = true; splitEl.innerHTML = ''; return; }
    splitEl.innerHTML = splitHtml(split.ready, split.pre);
    splitEl.hidden = false;
  }

  function fillTokens(tpl, title, split) {
    return tpl
      .replace(/\[product\]/g, '<strong>' + escapeHtml(title) + '</strong>')
      .replace(/\[preorder_qty\]/g, split ? String(split.pre) : '')
      .replace(/\[ready_qty\]/g, split ? String(split.ready) : '');
  }

  function showFor(item, split) {
    currentLineKey = item.key || null;
    var title = item.product_title || item.title || '';
    var img = item.image || (item.featured_image && item.featured_image.url) || '';

    if (titleEl) titleEl.textContent = title;
    if (variantEl) {
      var v = item.variant_title;
      variantEl.textContent = (v && v !== 'Default Title') ? v : '';
    }
    if (priceEl) priceEl.textContent = (item.price != null) ? money(item.price) : '';
    if (thumbEl) thumbEl.style.backgroundImage = img ? 'url("' + img + '")' : '';
    if (cardEl) cardEl.hidden = false;

    if (mediaEl && imageEl) {
      if (img) {
        imageEl.src = img; imageEl.hidden = false; mediaEl.hidden = false;
        if (dialogEl) dialogEl.classList.remove('preorder-popup__dialog--no-media');
      } else {
        imageEl.hidden = true; mediaEl.hidden = true;
        if (dialogEl) dialogEl.classList.add('preorder-popup__dialog--no-media');
      }
    }

    if (messageEl) {
      var isPartial = !!(split && split.ready > 0 && partialTemplate);
      messageEl.innerHTML = fillTokens(isPartial ? partialTemplate : messageTemplate, title, split);
    }
    renderSplit(split);

    if (SUPPRESS_DRAWER) keepDrawerClosed();
    open();
  }

  function closeCartDrawer() {
    var drawer = document.querySelector('cart-drawer') || cartDrawerEl();
    if (!drawer) return;
    if (typeof drawer.close === 'function') { try { drawer.close(); } catch (e) {} }
    ['active', 'animate', 'is-open', 'open', 'is-active', 'drawer--active', 'js-drawer-open'].forEach(function (c) {
      if (drawer.classList) drawer.classList.remove(c);
    });
    ['overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet', 'js-drawer-open', 'cart-drawer-open', 'no-scroll', 'scroll-lock'].forEach(function (c) {
      document.body.classList.remove(c);
      document.documentElement.classList.remove(c);
    });
  }

  // The theme opens the drawer a beat after add; close it across a short window.
  function keepDrawerClosed() {
    closeCartDrawer();
    [30, 120, 260, 450].forEach(function (t) { setTimeout(closeCartDrawer, t); });
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer') || cartDrawerEl();
    if (!drawer) return;
    if (typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) {} }
    ['active', 'is-open', 'open'].forEach(function (c) { if (drawer.classList) drawer.classList.add(c); });
    document.body.classList.add('overflow-hidden');
  }

  // Confirm-before-add: re-fire the add we blocked, letting the theme add the
  // item AND open its own drawer. bypassOnce lets this one submit through;
  // skipInspectUntil stops the post-add hook re-opening the popup.
  function performAdd(form) {
    if (!form) { close(); return; }
    skipInspectUntil = Date.now() + 2500;
    bypassOnce = true;
    pendingForm = null;
    close();
    if (form.requestSubmit) form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }

  function showForVariant(variantId, split) {
    var d = (window.PreorderData && window.PreorderData[variantId]) || {};
    showFor({
      key: null,
      product_title: d.t || '',
      variant_title: d.v || '',
      price: (d.p != null ? d.p : null),
      image: d.img || ''
    }, split);
  }

  function isPreorderVariant(variantId) {
    var map = window.PreorderVariants;
    return !!(map && map[variantId] === true);
  }

  // { e: can go on pre-order, a: units in stock } from pre-order-variants.liquid.
  // Falls back to the old all-or-nothing map if the stock map isn't on the page.
  function stockFor(variantId) {
    var s = window.PreorderStock && window.PreorderStock[variantId];
    if (s) return s;
    if (isPreorderVariant(variantId)) return { e: true, a: 0 };
    return null;
  }

  // How many of `qty` (added on top of `inCart` already in the cart) go on pre-order.
  function splitFor(variantId, inCart, qty) {
    var s = stockFor(variantId);
    if (!s || !s.e) return null;
    var avail = Math.max(0, s.a || 0);
    var before = Math.max(0, inCart - avail);
    var after = Math.max(0, inCart + qty - avail);
    var pre = after - before;
    if (pre <= 0) return null;
    return { pre: pre, ready: qty - pre };
  }

  function readQty(form) {
    var el = form.elements && form.elements.quantity;
    if (el && el.length && !el.value) el = el[0]; // RadioNodeList guard
    var q = parseInt(el && el.value, 10);
    return q > 0 ? q : 1;
  }

  // Total units of this variant already in the cart (all lines).
  function cartQty(variantId) {
    var f = nativeFetch || window.fetch;
    return f('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return (cart.items || []).reduce(function (n, it) {
          return String(it.variant_id || it.id) === String(variantId) ? n + it.quantity : n;
        }, 0);
      });
  }

  // ---------------------------------------------------------------------------
  // Slow variant switching
  // The theme only updates the form's variant id AFTER it has fetched the new
  // variant from the server. Until then the form still holds the previous
  // variant, so a quick click would be checked (and added) as the wrong one.
  // We mark the product as "loading" when an option changes, and clear it when
  // the theme writes the new id into the form (it fires a change event on it).
  var LOADING_MAX_MS = 8000; // never wait longer than this

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.name === 'id') { // theme finished updating the variant
      document.querySelectorAll('product-info').forEach(function (p) { p.__poLoadingAt = 0; });
      return;
    }
    var pi = t.closest('product-info');
    if (pi && t.closest('variant-selects')) pi.__poLoadingAt = Date.now();
  }, true);

  function productInfoFor(form) {
    var pi = form.closest && form.closest('product-info');
    if (pi) return pi;
    // Sticky add-to-cart bar sits outside product-info but follows the main product.
    if (form.closest && form.closest('#shopify-section-sticky-atc-bar')) {
      return document.querySelector('product-info[id^="MainProduct"]') || document.querySelector('product-info');
    }
    return null;
  }

  function isLoading(form) {
    var pi = productInfoFor(form);
    return !!(pi && pi.__poLoadingAt && Date.now() - pi.__poLoadingAt < LOADING_MAX_MS);
  }

  // Note: product forms contain <input name="id">, which shadows form.id.
  // Always read the form's own id attribute instead.
  function formId(form) { return form.getAttribute && form.getAttribute('id'); }

  // Resolves with the form to use once the variant has settled. If the theme
  // swapped in a whole new product, the old form is gone, so use its replacement.
  function settle(form) {
    var started = Date.now();
    return new Promise(function (resolve) {
      (function check() {
        if (!form.isConnected) { var fid = formId(form); return resolve(fid ? document.getElementById(fid) : null); }
        if (!isLoading(form) || Date.now() - started > LOADING_MAX_MS) return resolve(form);
        setTimeout(check, 100);
      })();
    });
  }

  function setBusy(form, on) {
    var btns = [].slice.call(form.querySelectorAll('[type="submit"]'));
    var fid = formId(form);
    if (fid) btns = btns.concat([].slice.call(document.querySelectorAll('[type="submit"][form="' + fid + '"]')));
    btns.forEach(function (b) {
      b.classList.toggle('btn--loading', on);
      if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
    });
  }

  // ---------------------------------------------------------------------------
  // Missing stock data
  // Data is printed on page load. When the theme swaps to a sibling product on
  // option change, scripts in the new HTML never run, so that product has no
  // data. Fetch it live from sections/pre-order-data.liquid instead.
  function localise(path) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (/^https?:/i.test(path)) { try { path = new URL(path).pathname; } catch (e) {} }
    if (root !== '/' && path.indexOf(root) !== 0) path = root + path.replace(/^\//, '');
    return path;
  }

  function productUrlFor(form) {
    var pi = productInfoFor(form);
    var url = pi && pi.dataset && pi.dataset.url;
    if (!url && form.closest) { // product card quick-add
      var card = form.closest('product-card, .card, .product-card, [class*="card"], li');
      var a = card && card.querySelector('a[href*="/products/"]');
      url = a && a.getAttribute('href');
    }
    return url ? localise(url.split('?')[0]) : null;
  }

  var dataRequests = {};
  function ensureData(variantId, productUrl) {
    if (stockFor(variantId) || !productUrl) return Promise.resolve();
    if (!dataRequests[productUrl]) {
      var f = nativeFetch || window.fetch;
      dataRequests[productUrl] = f(productUrl + '?section_id=pre-order-data', { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('[data-preorder-json]');
          if (!el) return;
          var json = JSON.parse(el.textContent);
          window.PreorderStock = Object.assign(window.PreorderStock || {}, json.stock || {});
          window.PreorderData = Object.assign(window.PreorderData || {}, json.data || {});
        })
        .catch(function () { delete dataRequests[productUrl]; }); // allow a retry later
    }
    return dataRequests[productUrl];
  }

  // After an add that we didn't intercept: show the split for the whole line.
  function inspect(items) {
    if (Date.now() < skipInspectUntil) return; // just confirmed, don't re-open popup
    items.forEach(function (item) {
      var id = item.variant_id || item.id;
      if (MATCH_ALL) { showFor(item, null); return; } // testing mode
      ensureData(id, item.handle ? localise('/products/' + item.handle) : null).then(function () {
        var s = stockFor(id);
        if (!s || !s.e) return;
        return cartQty(id).then(function (total) {
          var sp = splitFor(id, 0, total); // whole line vs stock
          if (sp) showFor(item, sp);
        });
      }).catch(function () {});
    });
  }

  function normalize(data) {
    if (!data) return [];
    if (Array.isArray(data.items)) return data.items;
    if (data.id) return [data];
    return [];
  }

  // Confirm-before-add: block the theme's add for pre-order items, show the popup first.
  if (CONFIRM_ADD) {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.getAttribute) return;
      if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
      if (bypassOnce) { bypassOnce = false; return; } // confirmed add: let it through
      var idInput = form.querySelector('[name="id"]');
      if (!idInput) return;
      var id = idInput.value;

      // Not safe to decide yet: the variant is still loading, or we have no stock
      // data for it. Hold the add, wait/fetch, then run this same check again.
      var needsWait = isLoading(form);
      var needsData = !stockFor(id) && form.__poTried !== id;
      if (needsWait || needsData) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (form.__poHolding) return; // already waiting, ignore extra clicks
        form.__poHolding = true;
        setBusy(form, true);
        var done = function (target) {
          form.__poHolding = false;
          setBusy(form, false);
          if (!target || !target.isConnected) return;
          if (target.requestSubmit) target.requestSubmit();
          else target.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        };
        settle(form).then(function (f) {
          if (!f) return null;
          var fid = (f.querySelector('[name="id"]') || {}).value;
          f.__poTried = fid; // fetch at most once per variant, so this can never loop
          return ensureData(fid, productUrlFor(f)).then(function () { return f; });
        }).then(done, function () { done(form); });
        return;
      }

      var s = stockFor(id);
      if (!s || !s.e) return; // can't go on pre-order: add as usual

      var qty = readQty(form);

      e.preventDefault();
      e.stopImmediatePropagation();
      pendingForm = form;

      if (s.a <= 0) { // nothing in stock: every unit is pre-order, no cart lookup needed
        showForVariant(id, { pre: qty, ready: 0 });
        return;
      }

      cartQty(id).then(function (inCart) {
        if (pendingForm !== form) return; // shopper moved on
        var sp = splitFor(id, inCart, qty);
        if (sp) showForVariant(id, sp);
        else performAdd(form); // enough stock: add normally, no popup
      }).catch(function () { performAdd(form); });
    }, true);
  }

  var isAddUrl = function (u) { return /\/cart\/add(\.js)?(\?|$)/.test(u || ''); };

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function () {
      var url = arguments[0];
      var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
      return origFetch.apply(this, arguments).then(function (res) {
        if (isAddUrl(urlStr) && res.ok) {
          res.clone().json().then(function (d) { inspect(normalize(d)); }).catch(function () {});
        }
        return res;
      });
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) { this._preUrl = url; return origOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (isAddUrl(xhr._preUrl)) {
      xhr.addEventListener('load', function () {
        try { inspect(normalize(JSON.parse(xhr.responseText))); } catch (e) {}
      });
    }
    return origSend.apply(this, arguments);
  };
})();

  } catch(e) { console.error(e); }
})();
})();
